module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "h1chap"
  }, [_c('span', {
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Chapter 1 "), _c('span', {
    staticClass: "heading_break"
  }, [_vm._v("What Is Retirement?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ask twenty people what retirement means, and you’ll get twenty different answers, but you’ll also hear some common themes. Retirement is about freedom and flexibility. It’s defined by being able to stop trading time for money, but it doesn’t mean you can’t work if you want to. Retirement puts you in charge of your time. That’s where retirement savings come in: To fund that phase of your life, you need to have access to a secure money supply.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0321b7ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781507212257/xhtml/ch01.vue
// module id = 69
// module chunks = 0